import { inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { tap } from 'rxjs/operators';
import { GeneralService } from '../services/general.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  const dialog = inject(MatDialog);
  const token = localStorage.getItem('token');
  const generalService = inject(GeneralService);

  if (token === null) {
    dialog.closeAll();
    router.navigate(['/login']);
    localStorage.removeItem('token');
    return next(req);
  } else {
    const cloned = req.clone({
      setHeaders: {
        Authorization: `${token}`,
      },
    });
    return next(cloned).pipe(
      tap((event: any) => {
        // Si la respuesta tiene Result === 'E00026', cerrar sesión y redirigir
        if (event?.body?.Result === 'E00026') {
          dialog.closeAll();
          localStorage.removeItem('token');
          router.navigate(['/login']);
          generalService.viewSnacAlert(event?.body?.Message, 'alert', 'Cierre de sesión');
        }
      }),
    );
  }
};
